<template>
    <div class="noapp-nodoc-page">
        <header4IQ :fromapp="'ug'" :pagename="'noAppNoDoc'"></header4IQ>
        <div class="message">
            <span class="title font-weight-black">No Apps or Docs Configured, Please contact your Admin..</span>
        </div>
    </div>
</template>
<script>
import header4IQ from '../../../common/components/header';
export default {
    name: 'noapp_nodoc',
    components:{
        header4IQ,
    },
}
</script>
<style lang="scss">
    .noapp-nodoc-page{
        .message{
            border: 2px solid indigo;
            text-align: center;
            padding: 2rem;
            width: fit-content;
            position: absolute;
            top: 50%;
            left: 35%;
        }
    }
</style>
